import { useSyncExternalStore } from 'react'
import { DocumentStore } from './DocumentStore'

export function useDocumentType(document: Document) {
  return useSyncExternalStore(
    (callback) => {
      document.addListener(callback)
      return () => document.removeListener(callback)
    },
    () => document.constructor.name
  )
}

// TODO: will update when document instance chnges?
export function useDocumentText(document: Document) {
  return useSyncExternalStore(
    (callback) => {
      const listener = (change: 'text' | 'data') => {
        if (change === 'text') {
          callback()
        }
      }
      document.addListener(listener)
      return () => document.removeListener(listener)
    },
    () => {
      document.reloadContent().catch(console.error)
      return document.text
    }
  )
}

export function useDocumentError(document: Document) {
  return useSyncExternalStore(
    (callback) => {
      document.addListener(callback)
      return () => document.removeListener(callback)
    },
    () => document.error()
  )
}

export type DocumentListener = (change: 'text' | 'data') => void

export abstract class Document {
  constructor(readonly store: DocumentStore) {}

  abstract get text(): string | undefined
  abstract updateText(text: string): Promise<void>

  abstract error(): Error | undefined

  abstract reloadContent(): Promise<void>

  // Listeners

  private listeners = new Set<DocumentListener>()

  addListener(listener: DocumentListener) {
    this.listeners.add(listener)
  }

  removeListener(listener: DocumentListener) {
    this.listeners.delete(listener)
  }

  dispatchChange(change: 'text' | 'data' = 'data') {
    this.listeners.forEach((listener) => listener(change))
  }
}

export interface DependentDocument extends Document {
  onDependencyChange: () => void
}
